import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SignInSso() {
  const { user } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/');
    }
  });
  //page to fake sign in but have an actual address
  return <div></div>;
}
